import { R } from 'core/helpers'
import { useCompanyId } from 'core/stores'
import { Permission, useUserPermissions_get } from 'core/types'

export type Access = 'loading' | 'allowed' | 'denied'

export const hasAll = (granted: ReadonlyArray<string> | undefined, required: ReadonlyArray<Permission>) =>
  required.every((permission) => granted?.includes(permission) ?? false)

type UseAccessOptions = {
  checkedCompanyId?: string
}

const useAccess = (
  requiredPermissions?: Permission | ReadonlyArray<Permission>,
  { checkedCompanyId }: UseAccessOptions = {},
): Access => {
  const sessionCompanyId = useCompanyId()
  const { data: permissionsByCompany, isLoading } = useUserPermissions_get({})

  const required: ReadonlyArray<Permission> =
    requiredPermissions === undefined ? []
    : typeof requiredPermissions === 'string' ? [requiredPermissions]
    : requiredPermissions

  if (required.length === 0) return 'allowed'

  if (R.isNil(permissionsByCompany) || isLoading) return 'loading'

  const granted = permissionsByCompany[checkedCompanyId ?? sessionCompanyId]

  return hasAll(granted, required) ? 'allowed' : 'denied'
}

export default useAccess
